// Phase 6.6 B — distinct gnss_systems combos in the DB.
//
// Drives the auto-discovering accordion filter on the Аналитика
// screen. Cached for 60 seconds because the available combos
// change rarely (only when a brand-new combo gets requested);
// the analytics view's 30-second refresh tick would otherwise
// re-fetch this list every cycle for no benefit.

import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';
import type { AnalyticsAvailableConfigsResponse } from '../api/types';

export function useAvailableConfigs() {
  return useQuery<AnalyticsAvailableConfigsResponse>({
    queryKey: ['analytics', 'available-gnss-configs'],
    queryFn: () => api.getAvailableGnssConfigs(),
    staleTime: 60_000,
  });
}
